'use client';
import { useEffect, useRef, useState } from 'react';

// Mounts children only once the element scrolls near the viewport, so components
// that run continuous work while mounted (rAF-driven tickers, autoplaying carousels)
// don't burn main-thread time while off-screen.
export default function useInView({ rootMargin = '200px' } = {}) {
  const ref = useRef(null);
  const [inView, setInView] = useState(false);

  useEffect(() => {
    if (inView || !ref.current) return;
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setInView(true);
          observer.disconnect();
        }
      },
      { rootMargin }
    );
    observer.observe(ref.current);
    return () => observer.disconnect();
  }, [inView, rootMargin]);

  return [ref, inView];
}
